<template>
  <section>
    <div class="has-text-centered">
      {{ message }}
    </div>
  </section>
</template>

<script>
import ApiAuth from '@/api/auth'
export default {
  data () {
    return {
      message: 'Checking'
    }
  },
  created: function () {
    console.log(this.$route.params.hash)
    ApiAuth.get.confirmAccount(this.$route.params.hash).then(response => {
      console.log(response)
      if (response.body.success) {
        this.$router.push({name: 'Auth'})
        this.$snackbar.open({
          message: 'Account confirmed, you can sign in.',
          position: 'is-bottom-right',
          actionText: null
        })
      } else {
        this.message = 'An error occurred.'
      }
    }).catch(error => {
      console.log(error)
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PageAccountConfirmation.vue